<style scoped>
.first-name{
  font-size: 11.5px !important;
}
.overlay{
  position: fixed;
  z-index: 900;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.75);
  cursor: pointer;
}
.main-notes{
  position: fixed;
  top: 0px;
  right: 0px;
  width: 420px;
  z-index: 1000;
  height: 100%;
  color: rgb(255, 255, 255);
  background: linear-gradient(rgb(190, 162, 231) 0%, rgb(134, 183, 231) 100%);
  padding: 70px 0 0 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 13px 2px;
  overflow: scroll;
}
.form-container{
    padding: 0 20px;
}
.container ul {
  margin: 0;
  list-style: none;
  position: relative;
  padding: 0 20px 20px 90px;
  font-size: 13px;
}


.container ul:before {
  content: "";
  width: 1px;
  height: 100%;
  position: absolute;
  border-left: 2px solid #fff;
}
.container ul:before {
    content: "";
    width: 1px;
    height: 100%;
    position: absolute;
    border-left: 2px solid #fff;
}
.container ul li {
  position: relative;
  margin-left: 30px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 2px;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.08);
  padding-bottom: 10px;
}

.container ul li:not(:first-child) {
  margin-top: 20px;
}
.container ul li > span {
  width: 2px;
  height: 100%;
  background: #fff;
  left: -30px;
  top: 0;
  position: absolute;
}
.container ul li > span:before, .container ul li > span:after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  background: #fff;
  left: -3px;
  top: 0;
}
/*.container ul li span:after {
  top: 100%;
}*/
.container ul li > div {
  margin-left: 10px;
}
.container div .title, .container div .type {
  font-weight: 600;
  font-size: 13px;
  white-space: pre-line;
  word-break: break-word;
}
.container div .info {
  font-weight: 300;
}
.container div > div {
  margin-top: 5px;
}
.container span.number {
  height: 100%;
}
.container span.number span {
  position: absolute;
  font-size: 11px;
  left: -35px;
  font-weight: bold;
}
.container span.number span:first-child {
  top: 0;
}
.container span.number span:last-child {
  top: 100%;
}

#svgContainer{
    text-align: right;
    padding: 5px;
}

.notes-text{
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255,255,255,0.4);
  margin-bottom: 25px;
}
.notes-time{
   padding-right: 10px;
  width: 80px;

}
</style>
<template transition name="slide">
  <transition name="slide">
<div>
  <div class="container main-notes" style="">
    <div class="form-container">
      <div class="clearfix">
        <h5 class="pull-left">{{`${domainName}`}}</h5>
        <span class="pull-right" id="svgContainer" @click="addnote()">
          <svg width="18px" height="18px" aria-hidden="true" data-prefix="fal" data-icon="plus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-plus-circle fa-w-16 fa-2x"><path fill="currentColor" d="M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z" class=""></path></svg>
        </span>
      </div>
      <div class = "notes-text">
      <el-input
          type="textarea"
          :rows="2"
          placeholder="Please input notes"
          v-model="notesInput" v-on:keydown.enter="addnote">
      </el-input>
    </div>
    </div>
    <div v-if="notes.length > 0">
    <ul>
      <li v-for="(not,index) in notes.slice().reverse()">
        <span></span>
        <div>
          <div class="title first-name">{{`${not.created_by.first_name}`}}</div>
          <div class="type">{{`${not.note}`}}</div>
        </div> <span class="number"><span><span class="notes-time">{{ `${not.created}` | moment("MMM Do, h:mm:ss a") }}</span></span> <span></span></span>
      </li>
    </ul>
  </div>
  </div>
  <div class="overlay" @click="stepBack()"></div>
</div>
</transition>
</template>

<script type="text/javascript">
import axios from 'axios'
  export default {
    data() {
      return {
        notesInput: '',
        domainName: '',
        notes: [],
      }
    },
    created: function(){
      // window.addEventListener('scroll', this.handleScroll);
      axios.get(BASE_URL + 'v1/domains/'+ this.$route.params.domid + '/notes/?limit=20&offset=0', {
      })
      .then(response => {
        console.log(response)
        this.domainName = response.data['0'].name;
        this.notes = response.data['0'].notes;
        })
      .catch(error => {

      })
    },
    methods: {
        stepBack: function(){
          setTimeout(() => {  window.history.back(); }, 200);
        },
        handleScroll: function (event) {
            axios.get(BASE_URL + '/v1/domains/'+ this.$route.params.domid + '/notes/?limit=20&offset=0', {
            })
            .then(response => {
              console.log(response)
              this.notes = response.data.results;
              console.log(this.notes)

            })
            .catch(error => {

            })
        },

        addnote: function(){
          if(this.notesInput){
          axios.post(BASE_URL + 'v1/domains/'+ this.$route.params.domid +'/notes/', {
            domain: this.$route.params.domid,
            note: this.notesInput
            })
            .then(response => {

                 axios.get(BASE_URL + 'v1/domains/'+ this.$route.params.domid + '/notes/?limit=20&offset=0', {
                  })
                  .then(response => {
                    console.log(response)
                    this.domainName = response.data['0'].name;
                    this.notes = response.data['0'].notes;
                    this.notesInput = '';
                    })
                  .catch(error => {

                  })
            

            })
            .catch(error => {

            })
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Notes.vue?211bf762